import { v4 } from 'uuid';

import { LOOKUP_WITHOUT_PLATFORM } from '../example-payloads/lookup';

import { buildUrl } from './http-utils';

export const lookup = (
  authHeader: string,
  executionId: string,
  baseUrl: string
) => {
  const url = buildUrl(
    baseUrl,
    `merchant/workflows/payment-acceptance/executions/${executionId}/lookup`
  );

  return fetch(url, {
    method: 'POST',
    headers: { authorization: authHeader, 'x-idempotency-key': v4() },
    body: JSON.stringify(LOOKUP_WITHOUT_PLATFORM),
  });
};
